export { defineLocale, getSetGlobalLocale, listLocales } from './locale/locales.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /var/www/html/LASO/laso-client/node_modules/ngx-bootstrap/bs-moment/index.js
// module id = ../../../../ngx-bootstrap/bs-moment/index.js
// module chunks = vendor